<template>
  <div>
    <!-- 默认展示 1-6 月龄；需要 1-12 可自行传入 -->
    <NeuroStandardsTimeline
      api-base="https://api.yubinglabs.com/web/neuro/neuro_standards"
      :months="[1,2,3,4,5,6]"
      :domain-order="['大运动','精细动作','适应能力','语言','社会行为','交流互动警示行为']"
      :initial-month="initialMonth"
      :is-paid="isPaid"
    />
  </div>
</template>

<script>
import NeuroStandardsTimeline from '@/components/NeuroStandardsTimeline.vue';

export default { 
    components: { NeuroStandardsTimeline },
    computed: {
        initialMonth () {
            // 从 URL 参数中获取 month
            const month = this.$route.query.month;
            const parsedMonth = month ? parseInt(month) : null;
            console.log('URL 参数 month:', month, '解析后:', parsedMonth);
            return parsedMonth;
        },
        isPaid () {
            // 从 URL 参数中获取 isPaid
            return this.$route.query.isPaid === 'true';
        }
    }
};
</script>